import { FC } from "react";

import { IOrganizationContact } from "../../../../../../../../types/types";
import { ProfileEmailsWidget } from "../../../../../../components/profile";

type Props = {
  organization: IOrganizationContact;
};

export const OrganizationEmailsWidget: FC<Props> = ({ organization }) => {
  const primaryEmail = organization?.emails?.find(
    (email) => email.isPrimaryEmail,
  );
  const contactEmail =
    primaryEmail?.emailAddress || organization?.emails?.[0]?.emailAddress || "";

  return (
    <ProfileEmailsWidget
      contactEmail={contactEmail}
      route={`/organization/${organization?.id}/emails`}
    />
  );
};
